import { Grid } from "@mui/material";
import Remark from "./Remark";
import PurchaseSummary from "./Summary";
import { CustomizedBox } from "../../../Custom/CustomizedBox";
import TagList from "../../../UI/TagList";
import { useFormContext } from "react-hook-form";
import { useDisable } from "../../../../hooks/use-disable";
import { useTranslation } from "react-i18next";
import SubHeader from "../SubHeader";

interface Props {
  documentType: string;
}

const PurchaseFooter = ({ documentType }: Props) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const [disabled] = useDisable();

  return (
    <CustomizedBox>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={12} md={6.5} lg={6.5} xl={6.5}>
          <Remark />
          <SubHeader title={t("sales.tag_list")} sx={{ marginTop: 1 }} />
          <Grid container spacing={1.5} mt={0}>
            <TagList
              fullWidth
              control={control}
              documentType={documentType}
              name="tag_list"
              label={t("sales.tag_list")}
              getValues={getValues}
              setValue={setValue}
              disabled={disabled}
            />
          </Grid>
        </Grid>
        {documentType !== "purchase_request" && (
          <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
            <PurchaseSummary documentType={documentType} />
          </Grid>
        )}
      </Grid>
    </CustomizedBox>
  );
};

export default PurchaseFooter;
